import { useReducer, useCallback } from 'react'
import { p2e } from '../../../core/utils/common'

const initialState = {
	mobileOrEmail: '',
	affiliateCode: '',
	rulesAccepted: false,
	password: '',
}

const formReducer = (state, action) => {
	switch (action.type) {
		case 'SET_EMAIL':
			return {
				...state,
				mobileOrEmail: action.payload,
			}
		case 'SET_AFFILIATE_CODE':
			return {
				...state,
				affiliateCode: action.payload,
			}
		case 'TOGGLE_RULES_ACCEPTED':
			return {
				...state,
				rulesAccepted: !state.rulesAccepted,
			}
		case 'RESET':
			return initialState
		default:
			return state
	}
}

/**
 * Hook to manage authentication form state
 */
export const useAuthForm = () => {
	const [formState, dispatch] = useReducer(formReducer, initialState)

	const setEmail = useCallback((value) => {
		const normalizedValue = p2e(value)
		dispatch({ type: 'SET_EMAIL', payload: normalizedValue })
	}, [])

	const setAffiliateCode = useCallback((value) => {
		const normalizedValue = p2e(value)
		dispatch({ type: 'SET_AFFILIATE_CODE', payload: normalizedValue })
	}, [])

	const toggleRulesAccepted = useCallback(() => {
		dispatch({ type: 'TOGGLE_RULES_ACCEPTED' })
	}, [])

	const resetForm = useCallback(() => {
		dispatch({ type: 'RESET' })
	}, [])

	return {
		formState,
		setEmail,
		setAffiliateCode,
		toggleRulesAccepted,
		resetForm,
	}
}

